import React from "react";
import { Typography } from "@mui/material";
import { RadarChart } from "@mui/x-charts/RadarChart";

export default function CustomRadarChart({
  metricsWithName,
  metrics,
  values,
  percentages,
  valueFormatter,
}) {

  if (!metrics || metrics.length === 0 || !values || values.length === 0) {
    return (
      <Typography variant="body" color="text.secondary">
        No data available.
      </Typography>
    );
  }

  const series = [
    {
      label: "Total Point",
      data: values,
      color: "#183021ff",
      fillArea: true,
      valueFormatter: valueFormatter || ((v) => v),
    },
  ];

  if (percentages && percentages.length > 0 && values.some((v) => v > 0)) {
    series.push({
      label: "Pass Rate",
      data: percentages,
      color: "#FFD166",
      fillArea: true,
      valueFormatter: valueFormatter || ((v) => v),
    });
  }

  const nameCount = {};
  if (Array.isArray(metricsWithName)) {
    metricsWithName.forEach((m) => {
      const name = m.name || m.metric || "Unknown";
      nameCount[name] = (nameCount[name] || 0) + 1;
    });
  }

  // ✅ Map metrics → readable + unique names
  const radarMetrics = (metrics || []).map((m, idx) => {
    let baseName = "Unknown";

    if (Array.isArray(metricsWithName) && metricsWithName[idx]) {
      const obj = metricsWithName[idx];
      baseName = obj.name || obj.metric || obj.label || String(m);
    } else {
      const found =
        Array.isArray(metricsWithName) &&
        metricsWithName.find(
          (x) =>
            x.name === m ||
            x.metric === m ||
            x.key === m ||
            (typeof m === "object" &&
              (x.name === m.name || x.metric === m.metric))
        );
      if (found) baseName = found.name ?? found.label ?? String(m);
      else baseName = typeof m === "string" ? m : m?.name ?? m?.label ?? String(m);
    }

    const sameNameItems =
      metricsWithName?.filter((x) => x.name === baseName) || [];
    if (sameNameItems.length > 1) {
      const current = metricsWithName[idx];
      const uniqueSuffix = current?.id ?? idx + 1;
      return `${baseName} (${uniqueSuffix})`;
    }

    return baseName;
  });

  return (
    <RadarChart
      height={350}
      series={series}
      radar={{
        max: Math.max(...values, ...(percentages || []), 10),
        metrics: radarMetrics,
      }}
    />
  );
}
